function Tracking() {

    const that = this;

    // -- returns the proxy url with all required parameters
    this.getApiTrackingUrl = function (type, params) {

        let queryString = '?' + window.location.search.replace(/\?/g, '');

        // -- we may pass additional query parameters
        if (typeof params === 'object' && params !== null) {
            queryString += '&' + new URLSearchParams(params).toString();
        }

        return TRACKING_URL + queryString + '&type=' + type;
    }

    const track = async function (type, params) {
        return fetch(that.getApiTrackingUrl(type, params))
            .then(response => response.json())
    }

    this.view = async function (params) {
        return track('view', params);
    }

    this.click = async function (params) {
        return track('click', params);
    }
}